import range from 'lodash/range';
import {connect} from 'react-redux';
import classNames from 'classnames';

const Button = ({className, label, disabled, showLabel, arrows, onClick}) => (
    <button
        className={classNames('met-btn', className, {disabled})}
        title={label}
        onClick={onClick}
        disabled={disabled}
    >
        {showLabel ? label : null}
        {range(arrows).map(index => <span key={index} className="arrow" />)}
    </button>
);

Button.defaultProps = {
    className: null,
    showLabel: false,
    arrows: 0,
};

const mapDispatchToProps = (dispatch, {disabled, change, nextImage}) => ({
    onClick: disabled ? null : () => dispatch(change(nextImage)),
});

export default connect(undefined, mapDispatchToProps)(Button);
